export class CoolingDeficiencyLayout {
	public fields = [
		{ fieldName: 'coolingDeficiencyIndicator', label: 'Indicator' },
		{ fieldName: 'deficiencyType', label: 'Type' },
		{ fieldName: 'coolingDeficiencySeverity', label: 'Severity' },
		{ fieldName: 'descriptioncoolingDeficiency', label: 'Description' }
	];
}
